import { DriverSendMessage } from "../../DriverSendMessage";
import { EquipmentAssignments } from "../EquipmentAssignments";
import { EquipmentGroupWarnings } from "../EquipmentGroupWarnings";
import { MultiPreassignment } from "../MultiPreassignment";
import { SendLoad } from "../SendLoad";
import { DataSource, Label, Layout, Panel, Step, Stepper, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPreassignmentStepper extends Layout {
    labelZmitTitle: Label;
    layoutDriverSendMessage: DriverSendMessage;
    layoutEquipmentAssignments: EquipmentAssignments;
    layoutEquipmentGroupWarnings: EquipmentGroupWarnings;
    layoutMultiPreassignment: MultiPreassignment;
    layoutSendLoad: SendLoad;
    panelAddlTrailers: Panel;
    panelEquipmentGroupWarnings: Panel;
    panelEquipmentTextboxes: Panel;
    panelLoadInfoComponents: Panel;
    panelLoadInformation: Panel;
    panelSendEmail: Panel;
    panelTitle: Panel;
    sourceEquipmentGroup: DataSource;
    sourceMovementStops: DataSource;
    sourcePreassignments: DataSource;
    sourceZmitLoad: DataSource;
    stepAssignments: Step;
    stepSelect: Step;
    stepZmitLoad: Step;
    stepperPreassignment: Stepper;
    switchSendEmail: Switch;
    textboxConsigneeName: Textbox;
    textboxDriverInfo: Textbox;
    textboxDriverOne: Textbox;
    textboxDriverTwo: Textbox;
    textboxShipperName: Textbox;
    textboxTractor: Textbox;
    textboxTractorId: Textbox;
    textboxTrailer2: Textbox;
    textboxTrailer3: Textbox;
    textboxTrailer: Textbox;
    textboxTrailerId: Textbox;
}
